<template>
	<div class="body-mobile">
		<loading v-if="isLoading" :loading-text="'正在提交报名信息...'"></loading>
		<div class="wrapper-body">
			<div class="wrapper-body__header">
				<nav-step :active="3"></nav-step>
			</div>
			<div class="wrapper-body__body">
				<div class="wrapper-body__body__title">
					<p v-if="studentType == 1">填写信息<span>（5/5）</span></p>
					<p v-else>填写信息<span>（4/4）</span></p>
				</div>
				<div class="wrapper-body__body__container">
					<md-field style="padding-bottom:10px;">
						<div class="body-form-title">
							<span>预约到街道资料审核时间</span>
						</div>
						<div style="margin-top: .2rem;text-indent:.2rem;">
							<p>
								<span>审核街道：</span>
								<span>{{form.orderStreetName}}</span>
							</p>
						</div>
						<md-field-item
							v-if="yearList.length"
							title="预约时间"
							:placeholder="'请选择年月'"
							arrow="arrow-right"
							align="right"
							:content="timeString"
							@click.native="isDatePickerShow = true">
						</md-field-item>
						<div class="text-error" style="line-height:60px;" v-else-if="!loadingDate">没有可预约的年月！</div>
						<md-tab-picker
							title="请选择年月"
							:data="yearMonthData"
							v-model="isDatePickerShow"
							@change="handleChange"
						/>

						<!-- <md-check v-model="checked" label="只看可预约时间" /> -->
					</md-field>

					<div class="wrapper-table">
						<table>
							<thead>
								<tr>
									<th class="cell">
													日期
									</th>
									<th class="cell">
										时间
									</th>
									<th class="cell">
										可预约
									</th>
								</tr>
							</thead>
						</table>
					</div>
					<div class="container-table">
						<div>
							<ul
								v-if="quotaList.length"
								class="list-quota">
								<li
									v-for="(item, index) in quotaList"
									:class="{'active': form.signupQuotaId == item.id, 'disabled': item.residueNum == 0}"
									@click="handleClickTime(item, index)"
									:key="index">
									<span>{{item.dateText}}{{item.amPmName}}</span>
									<span>{{item.amPmName}}</span>
									<!-- <span v-if="item.amPmType === 1">{{ item.amBegin ? `${item.amBegin}~${item.amEnd}` : '09:30~12:00'}}</span> -->
									<!-- <span v-if="item.amPmType === 2">{{ item.pmBegin ? `${item.pmBegin}~${item.pmEnd}` : '14:00~17:00'}}</span> -->
									<span>余{{item.residueNum}}</span>
								</li>
							</ul>
							<div v-else class="text-error" style="margin-top:.3rem;">{{ time.length <= 0 ? '请选择预约时间！' : '没有可以预约的日期！'}}</div>
						</div>

					</div>

					<div class="box-tips">
						<p class="text-error" v-if="reserveTimeText !== '无'">你的预约时间为：<span>{{reserveTimeText}}</span></p>
						<p v-if="quotaList[0]">
							<span>上午：{{quotaList[0].amBegin ? (quotaList[0].amBegin + '-' + quotaList[0].amEnd) : '09:00-12:00'}}</span>
							&nbsp;&nbsp;
							<span>下午：{{quotaList[0].amBegin ? (quotaList[0].pmBegin + '-' + quotaList[0].pmEnd) : '14:00-17:00'}}</span>
						</p>
						<p>温馨提示：请带上相关资料在预约时间到审核街道办进行资料审查！</p>
					</div>
					<!-- <md-input-item
						type="phone"
						title="法定监护人手机号码"
						placeholder="请输入手机号码"
						is-amount
					></md-input-item> -->
				</div>
			</div>
			<div class="wrapper-body__footer">
				<div class="box-btns">
					<span class="button-primary" @touchstart="handlePreviousStep">上一步</span>
					<span class="button-primary-inset"
						@touchstart="handleNextStep">下一步</span>
				</div>
				<!-- <div><router-link :to="{path: 'bm_login', query: {signupNoticeId: $route.query.signupNoticeId}}">同意并遵守</router-link></div> -->
			</div>
		</div>
		<!-- <div class="box-btns">
			<span class="button-primary" @touchstart="handlePreviousStep">上一步</span>
			<span class="button-primary-inset"
				@touchstart="handleNextStep">下一步</span>
		</div> -->
  </div>
</template>

<script>
  import IndexCommon from '../index/mixins/index_common';
  import MobileCommon from '../index/mixins/mobile_common';
	import PageForm from '../index/mixins/page_bm_form';

  export default {
    mixins: [IndexCommon, MobileCommon, PageForm],
    components: {},
    data() {
      return {
				isLoading: false,

				yearMonthData: {
					name: 'year',
					label: '年',
					options: []
				},

				dayList: [],

				currentDate: new Date(),
				isDatePickerShow: false,
				// 出生日期
				birthday: '',

				loadingDate: false,
				yearList: [],
				quotaList: [],

				time: [],

				reserveTimeText: '无',

				orderDateOptions: []

			}
		},

		computed: {

			timeString() {
				return this.time.map(item => item.value).join('/');
			}
		},

		beforeRouteEnter(to, from, next) {
			console.log('', to, from);
			if (from.path == '/mobile/bm_info') {
				next(vm => {
					// 通过 `vm` 访问组件实例
					console.log('vm', vm.$router)
				})
			} else {
				next();
			}
		},

		created() {
      // 1. 更新formData
      this.updateFormData();
			console.log('[-> Step5] Form ::', this.form);

				this.getYearList();
				this.initDate();
			// 		if (this.form.signupQuotaId) {
			// }
		},

    mounted() {
			window._debug = this;
			 window.curStep = this.form;
      // 2. 转换formData中的某些字段到当前视图中
			// todo
    },
		methods: {
			async handleNextStep() {
        let { form, $message } = this;

        // 1.验证参数
        // todo

        // 2.转换formData格式，使数据格式和后端的保持一致（需要的才处理）
				// form[xxx] = xxx;

				if (!this.form.signupQuotaId || this.reserveTimeText==='无') {
					this.$message.error('请选择预约时间！');
					return;
				}

        form.studentType = this.studentType;
        form.signupNoticeId = this.$route.query.signupNoticeId;
        // 随迁子女街道修改时丢失bug
        if(this.studentType===2){
          form.guardian.streetCode = form.orderStreetCode;
          form.guardian.streetName = form.orderStreetName;
        }
				this.isLoading = true;
        // 3.Ajax提交formData到后端
        // todo
        let { data } = await this.$ajax.gateway('/bm/IStudentSignupApi_newProtocol', {
          body: form
				});

				// 网络请求完成等待500ms
				setTimeout(() => {
					this.isLoading = false;
				}, 500);

        console.log('-> data', data);

        if (data.code === 200) {
          // ::成功::
          sessionStorage.removeItem('signupMobileForm');
          this.$router.push({ path: './bm_info',
						query: {
              signupNoticeId: this.$route.query.signupNoticeId,
              idCard: form.student.idCard,
              studentSignupId: data.data
            } });
        } else {
          // ::失败::
          $message.error(data.message);
        }
			},

			initDate(date) {
				// let orderDate = this.$route.query.orderDate;
				let orderDate = sessionStorage.getItem('form_orderDate');

				if (orderDate) {
					// this.orderDate = orderDate;
					let dates = orderDate.split('-').slice(0, 2).filter(v => !!v);
					this.time = dates.map((v, index) => {
						return {
							value: v,
							index
						}
					});

					if (dates.length) {
						this.getQuotaList({ year: dates[0], month: dates[1] });
					}
				}
			},

			textRender() {
				const args = Array.prototype.slice.call(arguments)
				const typeFormat = args[0] // 类型
				// const column0Value = args[1] // 第1列选中值
				// const column1Value = args[2] // 第2列选中值
				const column2Value = args[3] // 第3列选中值
				if (typeFormat === 'dd') {
					return `*${column2Value}日`
				}
			},
			onDatePickerChange(columnIndex, itemIndex, value) {
				console.log(
					`[Mand Mobile] DatePicker Change\ncolumnIndex: ${columnIndex},\nitemIndex:${itemIndex},\nvalue: ${JSON.stringify(
						value
					)}`
				)
			},
			onDatePickerConfirm(columnsValue) {
				console.log(`[Mand Mobile] DatePicker Confirm\nvalue: ${JSON.stringify(columnsValue)}`)
				this.birthday = this.$refs.datePicker.getFormatDate('yyyy/MM')
			},

			handleChange({ options }) {
				console.log('change 年月', options);
				this.time = options;

				let yearIndex = options[0].index,
					monthIndex = options[1].index,
					month = options[1].value;

				this.dayList = this.yearList[yearIndex].nodes[monthIndex].nodes.map(v => {
					return month + '/' + v;
				});

				this.getQuotaList({ year: options[0].value, month: options[1].value });
			},

			handleClickTime(item, index) {
				// if (item.residueNum <= 0) {
				// 	this.$message.error('该日期不可预约！');
				// 	return;
				// }

				// 取消预约
				if (this.form.signupQuotaId == item.id) {
					this.form.signupQuotaId = '';
					this.reserveTimeText = '无';
				} else {
					this.form.signupQuotaId = item.id;
					this.reserveTimeText = item.quotaDate + ' ' + item.amPmName;
				}

				this.saveFormData(this.form);
			},

			async getQuotaList({ month, year }) {
				// let body = {
        //     day: '',
        //     month,
        //     year,
        //     signupNoticeId: this.$route.query.signupNoticeId,
        //     // schoolId: this.form.orderSchoolId || '',
        //     streetCode: this.form.orderStreetCode // 中小学必传
				// 	};
				// 查询指定通知的报名名额限制 #李茹钰/2019-03-12#
        // let { data } = await this.$ajax.gateway('/bm/ISignupQuotaApi_query', {
        //   body
				// });
        let {data,error} = await this.$ajax.gateway("/bm/ISignupQuotaApi_areaInfoFree", {
            "METHOD": "get",
            "areaCode": this.form.orderStreetCode,
            "noticeId": this.$route.query.signupNoticeId
        });
				if (data.data && data.data.length) {
					data.data.forEach(v => {
						v.dateText = v.quotaDate.slice(5).replace('-', '/');
						v.amPmName = ['全天', '上午', '下午'][v.amPmType]
					});

					this.quotaList = data.data.filter(v => v.quotaDate.substring(5, 7) === month);
					// this.quotaList.filter(v => v.quotaDate.substring(5, 7) === month)
					// 初始化预约时间显示
					let item = this.quotaList.find(v => v.id == this.form.signupQuotaId);
					if (item) {
						this.reserveTimeText = item.quotaDate + ' ' + item.amPmName;
					}
				}
			},

			// 获取年月日列表，并存入yearList
      async getYearList() {
				this.loadingDate = true;
        // 根据通知ID查询所有可预约的年月日列表 #李茹钰/2019-03-14#
        let { data, err } = await this.$ajax.gateway('/bm/ISignupQuotaApi_yearMonthDay', {
          signupNoticeId: this.$route.query.signupNoticeId
				});
				this.loadingDate = false;
        if (err) return this.$message.error('系统错误！查询年月日失败！');
        console.log('年月日列表', data);
				this.yearList = data.data;

				this.yearMonthData.options = this.formatYearData(this.yearList);
				// console.log('yearMonthData', this.yearMonthData);
			},

			formatYearData(data) {
				return data.map((item, index) => {
					let year = {
						value: item.name,
						label: item.name,
						index,
						children: {
							name: 'month',
							label: '月',
							options: []
						}
					};

					if (item.nodes && item.nodes.length) {
						year.children.options = item.nodes.map((v, i) => {
							return {
								value: v.name,
								label: v.name,
								index: i
							}
						});
					}

					return year;
				});
			}

		}
  }
</script>

<style lang="stylus" scoped>
	// .body-mobile
		// position absolute
		// width 100%
		// top 0
		// bottom 0
		// -webkit-overflow-scrolling touch
		// heigit 100%
		// .wrapper-body
		// 	height: 100%;
		// 	overflow: auto;
		// 	-webkit-overflow-scrolling touch
		// 	margin 0
		// 	padding 0 0.4rem
		// .box-btns
			// position absolute
			// left 0
			// right 0
			// bottom 0
			// margin-top .3rem
			// padding 30px 0
			// background: -webkit-linear-gradient(left, #32a9bb, #38c6ac);
			// background: -o-linear-gradient(left, #32a9bb, #38c6ac); /* Opera 11.1 - 12.0 */
			// background: -moz-linear-gradient(left, #32a9bb, #38c6ac); /* Firefox 3.6 - 15 */
			// background: linear-gradient(left, #32a9bb, #38c6ac)
			// .button-primary
			// 	margin-right 20px
	.wrapper-body__footer
		height 140px
	.wrapper-body__body__container
		display flex
		flex-direction column
	.container-table
		margin 0 40px
		flex 1
		position relative
		text-align center
		overflow-y auto
		.list-quota
			li
				display flex
				height 80px
				line-height 80px
				font-size:28px;
				color:rgba(53,185,191,1);
				// background-color #d8e8e9
				background-color #faf9f9
				margin 10px 0
				span
					display inline-block
					flex 1
				// span + span
				// 	border-left 1px solid #fff
			li.active
				color #fff
				background:rgba(53,185,191,1);
			li.disabled
				color:rgba(153,153,153,1);
	.wrapper-table
		text-align center
		padding 0 40px
		table
			width 100%
		thead
			background-color #faf9f9
			th
				width 33.3%
		tr
			border-bottom 1px solid #fff
		.cell
			// width 100px
			position relative
			height 100px
			font-size:28px;
			font-weight:400;
			color:rgba(102,102,102,1);
		.cell + .cell
				border-left 1px solid #fff
		.cell.active
			color #fff
			background:rgba(53,185,191,1);
		tbody
			.cell
				background-color #d8e8e9
				color #35b9bf
			.text-ampm-type
				color:rgba(102,102,102,1);
	.box-tips
		font-size:24px;
		text-align center
		margin 20px 0
		p
			margin 15px 0
</style>
